import globalData from '../../common/globalData'

/**产品信息 */
class ProductInfo{
  constructor(){
    /**产品图片 */
    this.img = ''
    /**产品ID */
    this.id = ''
    /**产品型号 */
    this.model = ''
    /**产品名称 */
    this.name = ''
    /**产品分类 */
    this._sort = ''
    /**产品状况 */
    this.productStatus = []
    /**计价单位 */
    this._unit = ''
    /**产品备注 */
    this.remark = ''
    /**产品长宽高重量 */
    this._long = ''
    this._width = ''
    this._height = ''
    this._weight = ''
    /**外箱长宽高重量 */
    this._boxLong = ''
    this._boxWidth = ''
    this._boxHeight = ''
    this._boxWeight = ''
    /**装箱数量 */
    this.boxNum = ''
  }
  set sort(newVal){
    this._sort = newVal
  }
  get sort(){
    return globalData.sortInputOptions[this._sort]
  }
  set unit(newVal){
    this._unit = newVal
  }
  get unit(){
    return globalData.unitInputOptions[this._unit]
  }
  get status(){
    return globalData.productStatusInputOptions[this.productStatus[0]]
  }
  get productSize(){
    let str = globalData.keepDecimalPoint(this.long, 1) + '*' +
      globalData.keepDecimalPoint(this.width, 1) + '*' +
      globalData.keepDecimalPoint(this.height, 1)
    return str
  }
  get boxSize(){
    let str = globalData.keepDecimalPoint(this.boxLong, 1) + '*' +
    globalData.keepDecimalPoint(this.boxWidth, 1) + '*' +
    globalData.keepDecimalPoint(this.boxHeight, 1)
    return str
  }
  set long(newVal){
    this._long = newVal
  }
  get long(){
    return this._long != '' ? globalData.keepDecimalPoint(this._long, 1): ''
  }
  set width(newVal){
    this._width = newVal
  }
  get width(){
    return this._width != '' ? globalData.keepDecimalPoint(this._width, 1): ''
  }
  set height(newVal){
    this._height = newVal
  }
  get height(){
    return this._height != '' ? globalData.keepDecimalPoint(this._height, 1): ''
  }
  set weight(newVal){
    this._weight = newVal
  }
  get weight(){
    return this._weight != '' ? globalData.keepDecimalPoint(this._weight, 2): ''
  }
  set boxLong(newVal){
    this._boxLong = newVal
  }
  get boxLong(){
    return this._boxLong != '' ? globalData.keepDecimalPoint(this._boxLong, 1): ''
  }
  set boxWidth(newVal){
    this._boxWidth = newVal
  }
  get boxWidth(){
    return this._boxWidth != '' ? globalData.keepDecimalPoint(this._boxWidth, 1): ''
  }
  set boxHeight(newVal){
    this._boxHeight = newVal
  }
  get boxHeight(){
    return this._boxHeight != '' ? globalData.keepDecimalPoint(this._boxHeight, 1): ''
  }
  set boxWeight(newVal){
    this._boxWeight = newVal
  }
  get boxWeight(){
    return this._boxWeight != '' ? globalData.keepDecimalPoint(this._boxWeight, 2): ''
  }
  /**1立方产品数量 */
  get numByCube(){
    if(this.boxNum == '' || this.boxLong == '' || this.boxWidth == '' || this.boxHeight == ''){
      return ''
    }
    let num = 1000000 / (this.boxLong * this.boxWidth * this.boxHeight)
    num = Math.floor(num * this.boxNum)
    return num
  }
  /**数据初始化 */
  init(){
    this.img = ''
    this.id = ''
    this.model = ''
    this.name = ''
    this.sort = ''
    this.productStatus = []
    this.unit = ''
    this.remark = ''
    this.long = ''
    this.width = ''
    this.height = ''
    this.weight = ''
    this.boxLong = ''
    this.boxWidth = ''
    this.boxHeight = ''
    this.boxWeight = ''
    this.boxNum = ''
  }
}

/**产品供应商类 */
class ProductSupplier{
  constructor(
    options = [],               // 供应商选项
    purchasePrice = null,       // 采购单价
    value = null,               // 选择的供应商
    visible = false,            // 是否聚焦供应商选择器
  ){
    this.options = options
    this.value = value
    this.visible = visible
    this.purchasePrice = purchasePrice
  }
  // 初始化数据
  initData(){
    this.options = []
    this.value = null
    this.visible = false
    this.purchasePrice = null
  }
}

export {
  ProductSupplier, ProductInfo
}
